import { lazy, Suspense, useEffect } from "react";
import Nav from "../components/landing/Nav";
import HeroV3 from "../components/landing/HeroV3";
import Footer from "../components/landing/Footer";
import { useSeo } from "../lib/seo";
import { track } from "../lib/analytics";

const BelowFold = lazy(() => import("../components/landing/BelowFold"));

export default function LandingV3() {
  useSeo({
    title: "Fundprints: Smart money leaves prints.",
    description: "How crowded is what you own? We grade 10,000+ funds by their disclosed buys, follow only the specialists, and read every stock, ETF and 401k fund, holding by holding.",
    path: "/",
    image: "/api/share/img/curve.png",
  });
  useEffect(() => {
    track("landing_viewed", {}, true);
  }, []);
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      tries += 1;
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        clearInterval(timer);
      } else if (tries > 20) clearInterval(timer);
    }, 150);
    return () => clearInterval(timer);
  }, []);
  return (
    <div data-testid="fundprints-landing-v3" className="min-h-screen bg-[#0B0E14]">
      <Nav />
      <main>
        <HeroV3 />
        <Suspense fallback={null}>
          <BelowFold />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
